import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    init() {
        this.$projects = this.$('project');
        this.$baseProjects = this.$('project');
        this.$projectWrapper = this.$('projectWrapper')[0];

        this.$title = this.$('target-title')[0];
        this.$date = this.$('target-date')[0];
        this.$visual = this.$('target-visual')[0];
        this.$categories = this.$('target-categories')[0];

        //Set the first project active
        this.firstBlood = true;
        // this.setActive(this.$projects[0]);

        if (window.isMobile) return;

        this.bindEnter = this.projectHover.bind(this);
        this.bindLeave = this.projectLeave.bind(this);
        // Handmade events
        this.$projects.forEach(el => {
            el.addEventListener('mouseenter', this.bindEnter);
            el.addEventListener('mouseleave', this.bindLeave);
        });
    }

    projectHover(e) {

        if (this.firstBlood) {
            this.$projects.forEach(project => {
                if (project.classList.contains('is-active')) {
                    project.classList.remove('is-active');
                }
            });
            this.firstBlood = false;
        }

        this.setActive(e.currentTarget);
    }

    setActive(el) {

        if (this.setActiveCall !== undefined) {
            this.setActiveCall.kill();
        }

        el.setAttribute('data-leaving', 'false');
        el.classList.add('is-active');

        this.setActiveCall = gsap.delayedCall(0.15, () => {
            if (el.classList.contains('is-active')) {
                let title = el.getAttribute('data-project-title');
                let categories = el.getAttribute('data-project-categories').replace(/,/g, '<br>');
                let date = el.getAttribute('data-project-date');
                let visualCount = el.getAttribute('data-project-visual-count');
                let visual = el.getAttribute('data-project-visual');

                if(this.$title) this.$title.innerText = title;
                if(this.$categories) this.$categories.innerHTML = categories;
                if(this.$date) this.$date.innerText = date;
                if(this.$visual) this.$visual.src = visual;
            }
        });
    }

    projectLeave(e) {
        let el = e.currentTarget;
        el.setAttribute('data-leaving', 'true');

        this.hoverDelayedCall = gsap.delayedCall(0.2, () => {

            if (el.getAttribute('data-leaving') == 'true') {

                el.setAttribute('data-leaving', 'false');
                el.classList.remove('is-active');

                let activeHoveringProjects = 0;

                this.$projects.forEach(project => {
                    if (project.classList.contains('is-active')) {
                        activeHoveringProjects++;
                    }
                });

                if (activeHoveringProjects === 0) {
                    if (this.setActiveCall !== undefined) {
                        this.setActiveCall.kill();
                    }

                    if(this.$title) this.$title.innerText = '';
                    if(this.$categories) this.$categories.innerHTML = '';
                    if(this.$date) this.$date.innerText = '';
                    if(this.$visual) this.$visual.src = "data:image/svg+xml,%3Csvg xmlns=`http://www.w3.org/2000/svg` viewBox='0 0 466 256 '%3E%3C/svg%3E";

                    this.firstBlood = true;
                }
            }
        });

    }

    filter({ filteredCategory, scrollTo = true }) {
        this.$projectWrapper.innerHTML = '';
        this.$orderedProject = new Array(this.$baseProjects.length);

        // First loop to add filteredProjects
        this.$baseProjects.forEach(project => {
            let categoriesId = project.getAttribute('data-project-categories-id').split(',');
            let isOk = false;

            categoriesId.forEach((category, index) => {
                category = category.replace(/\s/g, '');

                if (category == filteredCategory) {
                    isOk = true;
                }

                if (index == categoriesId.length - 1) {
                    if (isOk) {
                        if (project.classList.contains('is-disabled')) {
                            project.classList.remove('is-disabled');
                        }
                        this.$orderedProject.push(project);
                    }
                }
            });
        });

        this.$baseProjects.forEach(project => {
            let categoriesId = project.getAttribute('data-project-categories-id').split(',');
            let isOk = false;

            categoriesId.forEach(category => {
                if (category === filteredCategory) {
                    isOk = true;
                }
            });

            if (!isOk) {
                if (filteredCategory !== 'category-all') {
                    project.classList.add('is-disabled');
                } else {
                    project.classList.remove('is-disabled');
                }

                this.$orderedProject.push(project);
            }
        });

        this.$projects = this.$orderedProject;

        this.$projects.forEach($project => {
            this.$projectWrapper.appendChild($project);
        });

        // Scroll to
        if (window.isMobile) {
            if (html.classList.contains('has-filters-stick')) {
                this.call('scrollTo', { target: document.querySelector('.js-filters'), options: { offset: - document.querySelector('.js-header').getBoundingClientRect().height } }, 'Scroll');
            }
        } else {
            if(scrollTo) {
                this.call('scrollTo', { target: document.querySelector('.js-filters'), options: { offset: - document.querySelector('.js-header').getBoundingClientRect().height } }, 'Scroll');
            }
        }
    }

    triggerFiltersMobile(e) {
        if (e.way === 'enter') {
            html.classList.add('has-filters-stick');
            html.classList.remove('-hide');

        } else {
            if (html.getAttribute('data-direction') === 'down') {
                html.classList.add('-hide');
            } else {
                html.classList.remove('has-filters-stick');
            }
        }

    }

    destroy() {
        this.$projects.forEach(el => {
            el.removeEventListener('mouseenter', this.bindEnter);
            el.removeEventListener('mouseleave', this.bindLeave);
        });
    }
}
